import template from './leave_restriction_rules.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveRestrictionRuleHelpPageViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveRestrictionRuleHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveRestrictionRuleHelpPageViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveRestrictionRuleHelp',
	dialog_class: LeaveRestrictionRuleHelpPage,
	template: template,
	template_filename : "translation/dialogs/employee_fields_help",
	provider: 'ps'
};
